export default __webpack_public_path__ + "static/media/logo.3f21b984.png";